import { render, staticRenderFns } from "./social-club-admin-management.vue?vue&type=template&id=fd47ab7a&scoped=true&lang=pug"
import script from "./social-club-admin-management.js?vue&type=script&lang=js&external"
export * from "./social-club-admin-management.js?vue&type=script&lang=js&external"
import style0 from "./social-club-admin-management.vue?vue&type=style&index=0&id=fd47ab7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd47ab7a",
  null
  
)

export default component.exports